import { PAGES } from '@/constants/pages';
import { convertArchiveDate } from './blogUtils';

export const MAX_FOOTER_ARCHIVE_LINKS = 24;

export const capitalizeFirstLetter = (string) => {
	if (!string.match(/[a-zA-Z]/)) {
		return string;
	}

	let index = 0;
	while (!string.charAt(index).match(/[a-zA-Z]/)) {
		index++;
	}

	const prev = index === 0 ? '' : string.slice(0, index);
	const next = string.slice(index + 1);
	return prev + string.charAt(index).toUpperCase() + next;
};

export const createLinkObject = (archiveDate, locale) => {
	const stringDate = convertArchiveDate(archiveDate, locale);
	return {
		name: capitalizeFirstLetter(stringDate),
		url: `${PAGES.BLOG_ARCHIVES}/${archiveDate}`,
	};
};

export const createArchiveLinkColumns = (archiveDateList, locale) => {
	const result = [];
	const archiveLinkObject = archiveDateList.map((archiveDate) => createLinkObject(archiveDate, locale));
	for (let i = 0; i < archiveLinkObject.length; i += 3) {
		result.push({ archiveFooterLinks: archiveLinkObject.slice(i, i + 3) });
	}
	return result;
};

export const formatLinksDataToColumns = (t, archiveLinkList, locale) => {
	const validArchiveLinkList =
		archiveLinkList.length > MAX_FOOTER_ARCHIVE_LINKS ? archiveLinkList.slice(0, MAX_FOOTER_ARCHIVE_LINKS) : archiveLinkList;

	const archiveLinkColumn = [];

	let years = validArchiveLinkList.map((archiveDate) => archiveDate?.slice(-4));
	years = years
		.filter((year, index) => years.indexOf(year) === index)
		.sort((year1, year2) => parseInt(year2, 10) - parseInt(year1, 10))
		.map((year) => {
			let yearSection = validArchiveLinkList.filter((archiveDate) => archiveDate?.slice(-4) === year);
			yearSection = createArchiveLinkColumns(yearSection, locale);
			archiveLinkColumn.push({
				title: `${t('homePage.footer.sectionTitle')} ${year}`,
				archiveLinkColumn: yearSection,
			});
		});

	return archiveLinkColumn;
};
